module.exports = __webpack_public_path__ + "img/about2.d5c20ac5.jpg";